export const createLogCustom = (audit) => (log) => audit.logCustom(log);
